var TemplateLibraryHeaderView = require( 'kitbuilder-templates/views/parts/header' ),
	TemplateLibraryHeaderLogoView = require( 'kitbuilder-templates/views/parts/header-parts/logo' ),
	TemplateLibraryHeaderSaveView = require( 'kitbuilder-templates/views/parts/header-parts/save' ),
	TemplateLibraryHeaderMenuView = require( 'kitbuilder-templates/views/parts/header-parts/menu' ),
	TemplateLibraryHeaderPreviewView = require( 'kitbuilder-templates/views/parts/header-parts/preview' ),
	TemplateLibraryHeaderBackView = require( 'kitbuilder-templates/views/parts/header-parts/back' ),
	TemplateLibraryLoadingView = require( 'kitbuilder-templates/views/parts/loading' ),
	TemplateLibraryCollectionView = require( 'kitbuilder-templates/views/parts/templates' ),
	TemplateLibrarySaveTemplateView = require( 'kitbuilder-templates/views/parts/save-template' ),
	TemplateLibraryImportView = require( 'kitbuilder-templates/views/parts/import' ),
	TemplateLibraryPreviewView = require( 'kitbuilder-templates/views/parts/preview' ),
	TemplateLibraryLayoutView;

TemplateLibraryLayoutView = Marionette.LayoutView.extend( {
	el: '#kitbuilder-template-library-modal',

	regions: {
		modalContent: '.dialog-message',
		modalHeader: '.dialog-widget-header'
	},

	initialize: function() {
		this.getRegion( 'modalHeader' ).show( new TemplateLibraryHeaderView() );
	},

	getHeaderView: function() {
		return this.getRegion( 'modalHeader' ).currentView;
	},

	getTemplateActionButton: function( isPro ) {
		var templateId = '#tmpl-kitbuilder-template-library-' + ( isPro ? 'get-pro-button' : 'insert-button' );

		templateId = kitbuilder.hooks.applyFilters( 'kitbuilder/editor/template-library/template/action-button', templateId );

		var template = Marionette.TemplateCache.get( templateId );

		return Marionette.Renderer.render( template );
	},

	showLoadingView: function() {
		this.modalContent.show( new TemplateLibraryLoadingView() );
	},

	showTemplatesView: function( templatesCollection ) {
		this.modalContent.show( new TemplateLibraryCollectionView( {
			collection: templatesCollection
		} ) );

		var headerView = this.getHeaderView();

		headerView.tools.show( new TemplateLibraryHeaderSaveView() );
		headerView.menuArea.show( new TemplateLibraryHeaderMenuView() );
		headerView.logoArea.show( new TemplateLibraryHeaderLogoView() );
	},

	showImportView: function() {
		this.modalContent.show( new TemplateLibraryImportView() );
	},

	showSaveTemplateView: function( elementModel ) {
		this.modalContent.show( new TemplateLibrarySaveTemplateView( { model: elementModel } ) );

		var headerView = this.getHeaderView();

		headerView.tools.reset();
		headerView.menuArea.reset();
		headerView.logoArea.show( new TemplateLibraryHeaderLogoView() );
	},

	showPreviewView: function( templateModel ) {
		this.modalContent.show( new TemplateLibraryPreviewView( {
			url: templateModel.get( 'url' )
		} ) );

		var headerView = this.getHeaderView();

		headerView.menuArea.reset();

		headerView.tools.show( new TemplateLibraryHeaderPreviewView( {
			model: templateModel
		} ) );

		headerView.logoArea.show( new TemplateLibraryHeaderBackView() );
	}
} );

module.exports = TemplateLibraryLayoutView;
